import React, { useState } from "react";
import axios from "axios";
import toast from "react-hot-toast";
import * as Yup from "yup";
import { BasicForm } from "@components/shared";
import { useTranslation } from "react-i18next";

export default function RoleForm({
  id = null,
  name = "",
  onSuccess = () => {},
}) {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  function onSubmit(formData) {
    setLoading(true);

    if (id) return onUpdate(formData);

    return onCreate(formData);
  }

  function onCreate(formData) {
    axios
      .post(`/roles/`, formData)
      .then(({ data }) => {
        setLoading(false);
        toast.success(t("created"));
        onSuccess(data.response[0]);
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err);
      });
  }

  function onUpdate(formData) {
    axios
      .put(`/roles/${id}/`, {
        ...formData,
        role_id: id,
      })
      .then(() => {
        setLoading(false);
        toast.success(t("updated"));
        onSuccess();
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err);
      });
  }

  const fields = [
    {
      name: "name",
      label: t("name"),
      initialValue: name,
      required: true,
      schema: () => Yup.string().required(t("validation:required")),
    },
  ];

  return (
    <BasicForm
      buttonProps={{
        fullWidth: !id,
      }}
      loading={loading}
      onSubmit={onSubmit}
      fields={fields}
    />
  );
}
